import { render, staticRenderFns } from "./BaseLottie.vue?vue&type=template&id=48bdae40&"
import script from "./BaseLottie.vue?vue&type=script&lang=js&"
export * from "./BaseLottie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports